import { GROUP_ORDER } from 'bento-ordering/group_ordering/constants/entities';
import { WS_ABNORMAL_CLOSURE_CODE } from 'bento-ordering/group_ordering/constants/groupOrder';
import {
  BASE_GROUP_ORDERING_API_ENDPOINT,
  getGroupOrderEndpoint,
  getGroupOrderGuestEndpoint,
  getRemoveFromGroupOrderEndpoint
} from 'bento-ordering/base/constants/endpoints';
import {
  FETCH_REQUEST,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  CREATE_REQUEST,
  CREATE_SUCCESS,
  CREATE_FAILURE,
  DELETE_REQUEST,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  UPDATE_REQUEST,
  UPDATE_FAILURE,
  UPDATE_SUCCESS
} from 'bento-ordering/base/actions/actionTypes';
import {
  GROUP_ORDER_JOIN_REQUEST,
  GROUP_ORDER_JOIN_SUCCESS,
  GROUP_ORDER_JOIN_FAILURE,
  UPDATE_GUEST_REQUEST,
  UPDATE_GUEST_SUCCESS,
  UPDATE_GUEST_FAILURE,
  GROUP_ORDER_LEAVE_REQUEST,
  GROUP_ORDER_LEAVE_SUCCESS,
  GROUP_ORDER_LEAVE_FAILURE,
  GROUP_ORDER_REMOVE_GUEST,
  GROUP_ORDER_WEB_SOCKET_CONNECTION_FAILURE
} from 'bento-ordering/group_ordering/actions/actionTypes';
import { apiAction } from 'bento-ordering/base/utils/apiHelpers';

const getActionTypesForEntity = (actionTypes, entity) => {
  return actionTypes.map(type => ({
    type: `[${entity}] ${type}`,
    meta: { entity }
  }));
};

export const fetchGroupOrder = groupOrderSlug => async dispatch => {
  const endpoint = getGroupOrderEndpoint(groupOrderSlug);
  const actionTypes = getActionTypesForEntity(
    [FETCH_REQUEST, FETCH_SUCCESS, FETCH_FAILURE],
    GROUP_ORDER
  );

  dispatch(apiAction(endpoint, 'GET', actionTypes));
};

export const createGroupOrder = data => async dispatch => {
  const endpoint = BASE_GROUP_ORDERING_API_ENDPOINT;
  const actionTypes = getActionTypesForEntity(
    [CREATE_REQUEST, CREATE_SUCCESS, CREATE_FAILURE],
    GROUP_ORDER
  );

  return dispatch(apiAction(endpoint, 'POST', actionTypes, data));
};

export const joinGroupOrder = (groupOrderSlug, data) => async dispatch => {
  const endpoint = getGroupOrderGuestEndpoint(groupOrderSlug);
  const actionTypes = [
    GROUP_ORDER_JOIN_REQUEST,
    GROUP_ORDER_JOIN_SUCCESS,
    GROUP_ORDER_JOIN_FAILURE
  ];

  return dispatch(apiAction(endpoint, 'POST', actionTypes, data));
};

export const cancelGroupOrder = groupOrderSlug => async dispatch => {
  const endpoint = getGroupOrderEndpoint(groupOrderSlug);
  const actionTypes = getActionTypesForEntity(
    [DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE],
    GROUP_ORDER
  );

  return dispatch(apiAction(endpoint, 'DELETE', actionTypes));
};

export const leaveGroupOrder = (groupOrderSlug, uuid) => async dispatch => {
  const endpoint = getRemoveFromGroupOrderEndpoint(groupOrderSlug, uuid);
  const actionTypes = [
    GROUP_ORDER_LEAVE_REQUEST,
    GROUP_ORDER_LEAVE_SUCCESS,
    GROUP_ORDER_LEAVE_FAILURE
  ];

  return dispatch(apiAction(endpoint, 'DELETE', actionTypes));
};

export const updateGroupOrder = (groupOrderSlug, data) => async dispatch => {
  const endpoint = getGroupOrderEndpoint(groupOrderSlug);
  const actionTypes = getActionTypesForEntity(
    [UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE],
    GROUP_ORDER
  );

  return dispatch(apiAction(endpoint, 'PATCH', actionTypes, data));
};

export const removeGuest = guestUUID => ({
  type: GROUP_ORDER_REMOVE_GUEST,
  payload: { guestUUID }
});

export const confirmOrderItems = groupOrderSlug => async dispatch => {
  const endpoint = getGroupOrderGuestEndpoint(groupOrderSlug);
  const actionTypes = [
    UPDATE_GUEST_REQUEST,
    UPDATE_GUEST_SUCCESS,
    UPDATE_GUEST_FAILURE
  ];

  return dispatch(
    apiAction(endpoint, 'PUT', actionTypes, { done_ordering: true })
  );
};

export const handleGroupOrderWebSocketError = () => ({
  type: GROUP_ORDER_WEB_SOCKET_CONNECTION_FAILURE,
  payload: { status: WS_ABNORMAL_CLOSURE_CODE }
});
